export default __webpack_public_path__ + "static/img/25.5512e71.png";